
'use strict';
(function(angular) {
  angular.module('fetchtv.services')
    .factory('billingService', [
      '$http',
      '$q',
      'proxyprefix',
      function(
        $http,
        $q,
        proxyprefix,
      ) {
        /**
         * Call given method to retrieve billing data.
         * @param {String} methodName Name of api method to call
         * @param {Object} data Dictionary of key value pairs to send (`from` and `to` parameters are automatically generated if not supplied)
         **/
        function getBillingInfo(
          methodName,
          data,
        ) {
          const epocZero = new Date(0),
            tomorrow = new Date(+(new Date()) + (3600 * 1000 * 24));

          var requestData = angular.isDefined(data) ? data : {
            from: epocZero.toISOString(),
            to: tomorrow.toISOString()
          };

          return $http.post(proxyprefix + '/' + methodName, requestData)
            .then(function(result) {
              if (result.data.__meta__.error) {
                return $q.reject(result.data.__meta__.error);
              }
              delete result.data.__meta__;
              return result.data;
            });
        }

        /** Get billing status from API
         * @returns {Promise<Object>}
         **/
        function getBillingStatus() {
          return $http.post(`${proxyprefix}/getBillingStatus`)
            .then(
              response => {
                const data = response.data;
                if (data.__meta__.error) {
                  return $q.reject(data.__meta__.error);
                }
                delete data.__meta__;
                return data;
              });
        }

        /** Get subscription anniversary date.
         * @returns {Promise<Number>} Timestamp of subscription anniversary date.
         **/
        function getAnniversaryDate() {
          return getBillingInfo('getTransactions')
            .then(
              transactionsHistory => {
                if (transactionsHistory.InvoiceItem.length === 0) {
                  return null;
                }
                return transactionsHistory.InvoiceItem[0].Timestamp;
              });
        }

        /** Get anniversary date.
         * @returns {Promise<Number>} Timestamp.
         **/
        function getAnniversaryDateFromHistory(
          transactionsHistory,
        ) {
          if (angular.isUndefined(transactionsHistory.InvoiceItem)) {
            return $q.reject("No Invoices");
          }

          if (transactionsHistory.InvoiceItem.length === 0) {
            return null;
          }
          return transactionsHistory.InvoiceItem[0].Timestamp;
        }

        /**
         * Retrieve a list of invoices between a given date range.
         * @param {Date} from The beginning of the request period.
         * @param {Date} to The end of the request period.
         * @returns {promise} A list of invoices matching request.
         **/
        function getInvoices(
          from,
          to) {
          if (!from || !to) {
            return $q.reject('MISSING_PARAMETERS');
          }
          return getBillingInfo('getInvoices', {
            from: from.toISOString(),
            to: to.toISOString()
          })
            .then(function(result) {
              return result.Transaction;
            });
        }

        /**
         * Retrieve a list of transactions between a given date range.
         * @param {Date} from The beginning of the request period.
         * @param {Date} to The end of the request period.
         * @returns {promise} A list of invoices matching request.
         **/
        function getTransactionsHistory(
          from,
          to,
        ) {
          if (!from || !to) {
            return $q.reject('MISSING_PARAMETERS');
          }
          return getBillingInfo('getTransactions', {
            from: from.toISOString(),
            to: to.toISOString()
          })
            .then(function(result) {
              return result;
            });
        }

        return {
          getTransactionsHistory: getTransactionsHistory,
          getInvoices: getInvoices,
          getMonthlyInvoices: function() {
            return getBillingInfo('getInvoices');
          },
          getBillingStatus: getBillingStatus,
          getAnniversaryDate: getAnniversaryDate,
          getAnniversaryDateFromHistory: getAnniversaryDateFromHistory
        };
      }]);
})(angular);
